import { render } from "./B2CVideoSection.vue?vue&type=template&id=163b5de9&lang=pug"
import script from "./B2CVideoSection.vue?vue&type=script&setup=true&lang=js"
export * from "./B2CVideoSection.vue?vue&type=script&setup=true&lang=js"

import "./B2CVideoSection.vue?vue&type=style&index=0&id=163b5de9&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__